module.exports = __webpack_public_path__ + "static/media/pdf_icon_d.dfc5639c.svg";